// eslint-disable-next-line
export default {
    name: "AiChef",
    status: {
        router: true,
        redux: true
    }
}
